import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";

const NotificationsPage = () => {
  const theme = useThemeHook();

  return (
    <div
      style={{
        padding: "13px",
        overflowY: "scroll",
        backgroundColor: THEME_COLORS[theme].page_background_color,
      }}
    >
      <p>Notifications will appear here</p>
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default NotificationsPage;